module.exports = __webpack_public_path__ + "static/img/menageService.c4976378.png";